// What the service worker warms into the cache after activation. Each file must be a dynamically
// imported chunk so the build classifies it as lazy and keeps it out of the precache; the build
// asserts this. Online-only features are omitted since they need a network anyway.
export const lazyFeatureFiles = [
  'katapult-photo-viewer.js',
  'katapult-3d-view.js',
  'alternate-designs-dialog.js',
  'DataViews.js',
  'date-time-picker.js',
  'date-time-dialog.js',
  'FixMapErrors.js',
  'PrepForPostConstruction.js',
  'job-snapshots.js',
  'table-attribute-editor.js',
  'katapult-team-members-input.js',
  'katapult-cost-causer-input.js',
  'paper-money-input-ench.js',
  'flow.js'
];

// External assets that are not always fetched at page load.
export const externalAssetUrls = [
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/halo-yellow.svg',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps.svg',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps-disconnected.svg',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps-inaccurate.svg',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/apple-touch-icon.png',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/favicon-32x32.png',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/favicon-16x16.png',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/safari-pinned-tab.svg',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/favicon.ico',
  'https://storage.googleapis.com/katapult-pro-shared-files/photos/favicons/Katapult/browserconfig.xml'
];
